import React, { useState } from "react";
import DonutChart from "components/common/charts/DonutChart";
import RadialBar from "components/common/charts/RadialBar";
import ColumnBarChart from "components/common/charts/ColumnBarChart";
import AnnotatedLineChart from "components/common/charts/AnnotatedLineChart";
import StackedBarChart from "components/common/charts/StackedBarChart";
import allImgPaths from "assets/images";
import DonutChart2 from "components/common/charts/DonutChart2";
import InsightCardsOptions from "components/insights/InsightCardsOptions";
import FeteCountDown from "components/insights/FeteCountDown";
import BudgetSplit from "components/insights/BudgetSplit";
import ContractInvoice from "components/insights/ContractInvoice";
import BudgetRollOver from "components/insights/BudgetRollOver";
import BudgetUtilization from "components/insights/BudgetUtilization";
import Response from "components/insights/Response";

const Insights = ({ showGraph }: any) => {

  return (
    <div>
      <div className='py-5 px-5 bg-[#F9FAFB] rounded-bl-2xl min-h-[1230px]'>
        {/* Main Wrapper */}
        <div className=''>
          {/* First Row */}
          <div className='flex gap-x-6 mb-5 items-start'>
            {showGraph.feteCountDown && <FeteCountDown />}

            {showGraph.budgetSplit && <BudgetSplit />}

            {showGraph.contract && <ContractInvoice />}
          </div>

          {/* Second row */}
          <div className='flex gap-x-6 mb-5 items-start'>
            {showGraph.budgetRollOver && <BudgetRollOver />}

            {showGraph.budgetUtilize && <BudgetUtilization />}
          </div>

          {/* Third Row */}
          <div className='flex gap-x-6'>
            {showGraph.attendee_responses && <Response />}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Insights;
